import {
    fn, IInfOperation
} from '@common/utils';

import {
    $ModalRequestClose, IDialogService as DialogService
} from '@common/services/DialogService';

import * as rwf3 from '@common/rwf';

import { constants as kconstants, AsObservableArray, ReplaceObservableData, GetGridDataSource, UpdateGridOptions, WrapAsObservable, GetWindowSettings } from '@common/navkendo';
import {
    INavGrid,
    NavGridOptions, GetGridOptionSettings, INavGridImp
} from '@common/navkendo/navgrid';

import { InfListOptions } from '@common/navkendo';
import { NavSettingsService, InfUserSettingsAccess } from '@common/services/settingsservice';
import { KWFPreviewService } from '../../rwfpreview/KWFPreviewService';
import { NavPageItem, NavClientService } from '../../navdata/navdata';
import rwf3Pages = rwf3.Pages;
import { GridColumn, ObservableArray } from '@common/nav';
import { OpenRowItem } from '../../KWFUtils';
import { CompatibilityService } from '@services/compatibilityservice';
import { RouteInstanceModel, IKWFRoutingAction, IKWFComment, RouteInstanceModels, IRWFRoutingState, TRouteInstanceSource, ExternalRefresh } from "@common/rwf/routeinstancemodel";
import { IFDRW_WF_Action_Fwd_Comments_List, ReAuthenticate, ValidateSignature } from '@common/rwf';
const WFInstance = rwf3Pages.FDRW_WFInstance;

/** Controller for Routing multiple WorkFlows in KWF3 */
export class CtrlMassRouteInstances {
    static readonly Template = require('./massroute.ctrl.html');
    /** Show a Modal Window for Routing Many Workflows */
    public static ModalMassRouteInstances(this: void, $c: CompatibilityService, myInvoices: TRouteInstanceSource[], navUrl: string) {
        const $rwf = $c.resolve("Rwf");
        const $dlg = $c.resolve("DialogService");
        const NavSettings = $c.resolve("NavSettings");
        const $rwfBootstrap = $rwf("RwfBootstrap");
        const getUserInfo = $rwfBootstrap.Resolve.then((r) => r.RwfUser);

        return RouteInstanceModel.LoadRoutingInfo($c, myInvoices, navUrl).then(info => {
            var windowOptions = <kendo.ui.WindowOptions>{
                actions: ["Undo", "Maximize", "Close"],
                modal: true,
                resizable: true,
                width: 1195,
                height: 600, // AdaptivePanel in content needs fixed container height! (Can permanently shrink on grouping otherwise)
                minHeight: 292 // Height with 1 item in grid (ungrouped)
            };
            var shownWindow: kendo.ui.Window;
            var userSettings = NavSettings.CreateUserSettings(["KWF", "CtrlMassRouteInstances"]);
            userSettings.Add("ModalWindow", GetWindowSettings(windowOptions, () => shownWindow));

            /** Open Window with Resolved Information */
            var showWindow = $dlg.ShowWindow({
                controller: CtrlMassRouteInstances,
                template: CtrlMassRouteInstances.Template,
                windowOptions: windowOptions,
                resolve: {
                    "RouteInstanceModels": [fn.ToFunc(info)],
                    "CurrentUser": [fn.ToFunc(getUserInfo)],
                    "UserSettings": fn.ToFunc(userSettings)
                },
                titleFormula: "CurrentTitle"
            });

            // Attach MassWindow Reference to Controller (... bad)
            showWindow.then(w => {
                if ((shownWindow = w.window) && w.scope) {
                    // TODO : More Generic way ?
                    var undoEl = w.window.wrapper.find(".k-window-actions [aria-label='Undo']").attr("title", "Einstellungen zurücksetzen").bind("click.navCustom", (e) => {
                        e.preventDefault();
                        $dlg.ShowConfirm({ message: "Einstellungen zurücksetzen?" }).then(d => d && w.scope["ResetUserSettings"]());
                    }).parent().removeAttr("href"); // href : s.times href='#' ...;
                    w.scope["MassWindow"] = w.window;
                    w.scope.$on("$destroy", () => {
                        if (info) {
                            info.destroy();
                        }
                        w.scope["MassWindow"] = undefined;
                        undoEl.unbind(".navCustom");
                    });
                }
            });

            return showWindow;
        });
    }

    static $inject = ["$scope", "DialogService", "NavClient", "KWFPreviewService", "NavSettings", "RouteInstanceModels", "CurrentUser", "UserSettings"];
    constructor(
        $scope: ng.IScope,
        DialogService: DialogService,
        NavClient: NavClientService,
        KWFPreviewService: KWFPreviewService,
        NavSettings: NavSettingsService,
        RouteInstanceModels: RouteInstanceModels,
        CurrentUser: rwf3.IFDRW_WF_User,
        /** UserSettings  */
        UserSettings?: InfUserSettingsAccess
    ) {
        const WFInstances = RouteInstanceModels.Instances;
        const MyInvoiceClient = RouteInstanceModels.UserInstancesClient;
        var navUrl = WFInstances && WFInstances.length ? WFInstances[0].Instance.ClientInfo.Url : "";
        const $c = NavClient.$c;

        /** Currently Running Operation State Info */
        var operationInfo = $scope["Operation"] = RouteInstanceModels;

        /** Per Instance Information */
        function createInstanceInfo(wfInstance: RouteInstanceModel) {
            var wf = wfInstance.Instance;

            // Wrap as Obserable already here, as we access "current" in Methods! [(Underline["_"] for props: Prevent Wrapping from kendo ....)]
            var current = WrapAsObservable({
                ID: wfInstance.ID,
                /** the externally Attached Routing Information  */
                _Source: wfInstance,
                /** FDRW_WF_Instance Item */
                _Model: <rwf3.IFDRW_WFInstance><any>(wfInstance.Instance && wfInstance.Instance.Model),
                /** IFDRW_Workflow_User_Instances_List Item */
                MyInvoice: wfInstance.UserInstanceItem,
                /** Aggregated State Information */
                _State: <IRWFRoutingState>undefined,

                /** Action called when Selected Action Changes */
                SelectAction: (arg: kendo.ui.DropDownListSelectEvent | IKWFRoutingAction) => {
                    // Recalculate available comments
                    var e = <kendo.ui.DropDownListSelectEvent>arg;
                    if (e && e.sender && e.preventDefault)
                        var item = <IKWFRoutingAction>e.sender.dataItem(<any>e.item);
                    else
                        var item = <IKWFRoutingAction>arg;

                    wfInstance.SelectRoutingAction(item);

                    refreshCommonComments();
                    onSelected(<kendo.ui.DropDownListSelectEvent>arg);
                },

                EditRowItem: () => OpenRowItem($c, wfInstance.Model),
                ShowPDF: () => {
                    KWFPreviewService.ShowRowItemInfoByData(current.MyInvoice, MyInvoiceClient.MetaData, "Invoice");
                },
                ShowSupplDoc: ($event) => {
                    KWFPreviewService.ChooseRowItemSupplementDoc($event, current.MyInvoice, MyInvoiceClient.MetaData, "Invoice");
                },
                /* Refresh state information */
                RefreshState: (opt?: IRWFRoutingState) => {
                    var wasAutoDeselect = state.IsDone || state.IsError;
                    wfInstance.RefreshState(opt);

                    // DeSelect Done / Fatal Error Items if changed state
                    var isAutoDeselect = state.IsDone || state.IsError;
                    if (isAutoDeselect && !wasAutoDeselect) {
                        var grid = getGrid();
                        if (grid) {
                            grid.unselect(grid.getRowByUid(current["uid"]));
                        }
                    }
                },
            });
            /** state information for current Item (actually aggregated on the item right now) */
            var state = current._State = <IRWFRoutingState>current._Source;
            state.Disabled = state.IsDone = state.IsError = state.IsOpen = state.IsRefresh = false;

            // SetUp Options for Select Actions DropwDown
            current["UISelectTopActionOptions"] = <InfListOptions<IKWFRoutingAction>>{
                optionLabel: "Aktion wählen",
                select: current.SelectAction,
                dataSource: wfInstance.TopActions,
                dataTextField: "Title",
                dataValueField: "ID",
                disabledField: "ActionLocked",
                hintField: "ActionLockReason"
            };
            current["UISelectSubActionOptions"] = <InfListOptions<IKWFRoutingAction>>{
                optionLabel: "Aktion wählen",
                select: current.SelectAction,
                dataSource: wfInstance.CurrentSubActions,
                dataTextField: "_GroupedTitle",
                dataValueField: "ID",
                disabledField: "ActionLocked",
                hintField: "ActionLockReason"
            };

            // SetUp Options for Select Comments DropwDown
            current["UISelectCommentOptions"] = <InfListOptions<rwf3.IFDRW_WF_Action_Fwd_Comments_List>>{
                optionLabel: "Kommentar wählen",
                dataSource: wfInstance.CurrentAvailableComments,
                dataTextField: "Comment",
                dataValueField: "WorkflowForwardingComment"
            };

            try {
                // SetUp Close Action
                var currentClosing: PromiseLike<any>;
                var origClose = wfInstance.Close = () => {
                    if (!state.IsOpen || currentClosing)
                        return $c.when();

                    currentClosing = wf.ExecuteMethod(WFInstance.Methods.Close(wf.Key, false)).then(d => current.RefreshState({ IsOpen: false }));
                    wfInstance.Close = fn.ToFunc(currentClosing);
                    const resetClose = () => { currentClosing = undefined; wfInstance.Close = origClose; };
                    currentClosing.then(resetClose, resetClose);
                    return currentClosing;
                };

            } catch (err) {
                current.RefreshState({ Error: err });
            }

            return current;
        }
        // Object Equality in instanceData and instanceInfo ensured as Items "PreWrapped" as ObservableObjects
        /** User Selected, not yet succesfully Routed Instances(INitially all) */
        var selectedInstances = WFInstances.map(createInstanceInfo);

        var getCurrentTitle = () => {
            var selCount = selectedInstances ? selectedInstances.length : 0;
            return selCount + " Beleg" + (selCount != 1 ? "e" : "") + " weiterleiten";
        };
        $scope["CurrentTitle"] = getCurrentTitle();

        /** UI Bound Container of currently Displayed Instance Data (Caution : Manipulating (Delete ...)
        is a very heavyweight Operation as long as this container is the dataSource for a angualar aware Grid,
        as each change of collection will reCompile the whole Grid! */
        var instanceData = $scope["Instances"] = AsObservableArray(selectedInstances);

        // Refresh Selected Instances
        function updateSelectedInstances() {
            var infos = instanceData.filter(item => !selectionData || selectionData.indexOf(item) >= 0);
            selectedInstances = instanceData.filter(item => infos.indexOf(item) >= 0 && !item._State.IsDone == true && !item._State.IsError == true);

            $scope["CurrentTitle"] = getCurrentTitle();
        }
        var _refreshCounter = 0;
        // Refresh Common Info for a given selection of items (optional defer after promise)
        function refreshCommonActions(defer?: PromiseLike<any>) {
            if (defer && defer.then) {
                _refreshCounter++;
                const afterDefer = () => { _refreshCounter--; refreshCommonActions(); };
                defer.then(afterDefer, afterDefer);
                return;
            }
            if (_refreshCounter > 0)
                return;
            updateSelectedInstances();

            if (!commonInfo)
                return;

            var selActions = selectedInstances.map(info => info._Source.TopActions);
            var groupedActions = fn.GroupBy(fn.FlattenArray(selActions), actionId);
            commonInfo.Actions = fn.DictToArray(groupedActions).map(item => item.length == selActions.length ? item[0] : undefined).filter(fn.isSet);
            var selIds = fn.DictToArray(fn.GroupBy(selectedInstances, item => item._Source.SelectedAction && actionId(item._Source.SelectedAction)));
            if (selIds.length == 1 && selIds[0]) {
                var sm = selIds[0][0]._Source.SelectedAction;
                commonInfo.SelectedAction = (sm && commonInfo.Actions.filter(item => compareAction(item, sm))[0]) || undefined;
            } else {
                commonInfo.SelectedAction = undefined;
            }

            ReplaceObservableData(commonInfo.SubActions, <any[]>(commonInfo.SelectedAction && commonInfo.SelectedAction._Items) || [], actionId, (a, b) => a === b);
            refreshCommonComments();
        }

        /** Refresh Visualization for Common Comments */
        function refreshCommonComments() {
            if (!selectedInstances || !commonInfo)
                return;
            var selCount = selectedInstances.length;
            var availableComments = fn.DictToArray(fn.GroupBy(fn.FlattenArray(selectedInstances.map(item => item._Source.CurrentAvailableComments)), item => item.WorkflowForwardingComment));
            // Show Comments available for all Selected Instances
            commonInfo.CurrentComments = availableComments.filter(item => item.length == selCount).map(item => item[0]);

            if (commonInfo.CurrentComments.length > 0) {
                // PreSelect Common Comment of Selected Items
                var selComments = fn.DictToArray(fn.GroupBy(selectedInstances.map(item => item._Source.SelectedComment), c => (c && c.WorkflowForwardingComment) || undefined));
                commonInfo.SelectedComment = selComments.length == 1 ? selComments[0][0] : undefined;
            } else {
                commonInfo.SelectedComment = undefined;
            }
        }

        /** Refresh States for All Instances */
        function refreshInstanceStates() {
            if (instanceData) {
                instanceData.forEach(instance => instance.RefreshState());
            }
        }
        /** Selection might get triggered outside of angular scope ... force angular apply if necessary*/
        function onSelected(e: kendo.ui.DropDownListSelectEvent) {
            var scope = e && e.sender && <ng.IScope>e.sender["$angular_scope"];
            if (scope && scope.$root && !scope.$$phase && !scope.$root.$$phase)
                scope.$apply();
        }
        var commonInfo = $scope["CommonInfo"] = {
            Actions: <IKWFRoutingAction[]>[],
            SubActions: AsObservableArray<IKWFRoutingAction>([]),
            SelectedAction: <IKWFRoutingAction>undefined,
            SelectAction: (e: kendo.ui.DropDownListSelectEvent) => {
                var selectedAction = <IKWFRoutingAction>e.sender.dataItem(<any>e.item);
                if (!selectedAction || !selectedAction.WFActionCode)
                    return;

                // Propagate unique selected action match to all selected rows
                selectedInstances.forEach(info => {
                    const selMatches = info._Source.TopActions.filter(item => compareAction(item, selectedAction));
                    info.SelectAction(selMatches.length == 1 ? selMatches[0] : undefined);
                });

                ReplaceObservableData(commonInfo.SubActions, <any[]>(selectedAction && selectedAction._Items) || [], actionId, (a, b) => a === b);
                refreshCommonComments();
                onSelected(e);
            },
            SelectSubAction: (e: kendo.ui.DropDownListSelectEvent) => {
                var selectedAction = <IKWFRoutingAction>e.sender.dataItem(<any>e.item);
                if (!selectedAction || !selectedAction.WFActionCode)
                    return;

                // Propagate unique selected action match to all selected rows
                selectedInstances.forEach(info => {
                    const selMatches = info._Source.AllActions.filter(item => compareAction(item, selectedAction));
                    info.SelectAction(selMatches.length == 1 ? selMatches[0] : undefined);
                });

                refreshCommonComments();
                onSelected(e);
            },
            CurrentComments: <IFDRW_WF_Action_Fwd_Comments_List[]>[],
            SelectedComment: <IFDRW_WF_Action_Fwd_Comments_List>undefined,
            SelectComment: (e: kendo.ui.DropDownListSelectEvent) => {
                var selectedComment = <rwf3.IFDRW_WF_Action_Fwd_Comments_List>e.sender.dataItem(<any>e.item);

                // Propagate selected action to all selected rows
                selectedInstances.forEach(info => {
                    var match = (selectedComment && info._Source.CurrentAvailableComments.filter(item => item.WorkflowForwardingComment == selectedComment.WorkflowForwardingComment)[0]) || undefined;
                    info._Source.SelectedComment = match;
                });
                onSelected(e);
            },
            Remark: ""
        };

        /** Check Signatures are Valid on Items needing Signature, if not Show Modal Signing Window */
        function CheckSignMandatoryValid(): PromiseLike<any> {
            var signData = selectedInstances.filter(item => item._Source.SelectedAction && item._Source.SelectedAction.SignatureMandatory);
            var signIds = signData.map(item => item.ID);
            if (signIds.length == 0)
                return $c.when();

            const toValidate = signData.map(item => ({
                ID: item.ID,
                Instance: item._Source.Instance,
                SelectedAction: item._Source.SelectedAction,
                CurrentStep: item._Source.CurrentStep,
                Name: item.MyInvoice.Name || item.ID
            }));

            // Only Remove Erroneous Document on Sign Error
            var onSignError = (e: { ID: string, Instance: NavPageItem, Error?: string, Continue?: boolean }) => {
                var erroneous = selectedInstances.filter(s => s.ID == e.ID)[0];
                var idx = erroneous && selectedInstances.indexOf(erroneous);
                if (idx >= 0) {
                    erroneous.RefreshState({
                        IsError: true, SignDocError: true,
                        Error: ("" + e.Error) || "Fehler bei der Signatur"
                    });
                    selectionData.remove(erroneous);
                    updateSelectedInstances();
                    var sel = getGrid() && getGrid().GetSelectedItems();

                    idx = selectedInstances.indexOf(erroneous);
                    if (idx >= 0)
                        selectedInstances.splice(idx, 1);
                    if (sel)
                        sel.SetSelected(false, erroneous);
                    e.Continue = true;
                }
            };
            toValidate.forEach(t => t.Instance.Model.bind("RWFSignError", onSignError));
            return $c.finally(ValidateSignature(NavClient.$c, toValidate, navUrl), () => {
                toValidate.forEach(t => t.Instance.Model.unbind("RWFSignError", onSignError));
            });
        }

        /** Prepare Columns */
        var myInVoiceCols = MyInvoiceClient.MetaData.Properties.filter(p => p.Invisible !== true)
            .map(p => MyInvoiceClient.MetaData.GetColumn(p, { Prefix: "MyInvoice." })).filter(c => c.field != "Name");
        myInVoiceCols.forEach(c => c.hidden = c.field != "MyInvoice.Name" && c.field != "MyInvoice.Amount"); // Compat.

        var colSelectAction = <GridColumn>{
            title: "Aktion",
            field: "_Source.SelectedAction",
            width: 160,
            sortable: {
                compare: (a: { SelectedAction: IKWFRoutingAction }, b: { SelectedAction: IKWFRoutingAction }) => {
                    if (!a || !a.SelectedAction)
                        return (b && b.SelectedAction) ? -1 : 0;
                    else if (!b || !b.SelectedAction)
                        return 1;
                    return (a.SelectedAction.WFActionName || "").localeCompare(b.SelectedAction.WFActionName || "");
                }
            },
            groupable: false,
            template: require('./col/selectaction.html'),
        };
        var colSelComment = <GridColumn>{
            title: "Kommentar",
            field: "_Source.SelectedComment.Comment",
            width: 160,
            sortable: {
                compare: (a: { SelectedComment: IKWFComment }, b: { SelectedComment: IKWFComment }) => {
                    if (!a || !a.SelectedComment)
                        return (b && b.SelectedComment) ? -1 : 0;
                    else if (!b || !b.SelectedComment)
                        return 1;
                    return (a.SelectedComment.Comment || "").localeCompare(b.SelectedComment.Comment || "");
                }
            },
            groupable: false,
            template: require('./col/selcomment.html'),
        };
        var colState = <GridColumn>{
            title: "Status",
            width: "85px",
            filterable: false,
            menu: false,
            field: "_Source.IsRouting",
            template: require('./col/selstate.html'),
        };
        var colPreview = <GridColumn>{
            width: kconstants.KendoGrid_PreviewIconColumnSize,
            template: "<span class='idms_Image16 idms_Image_PDF16 idms_HoverImage' ng-click='dataItem.ShowPDF($event)' title='Dokument anzeigen'></span>" +
                "<span class='idms_Icon idms_Icon_Attachment idms_LinkIcon' ng-show='dataItem && (dataItem.MyInvoice.SupDocsCount > 0)' ng-click='dataItem.ShowSupplDoc($event)' title=\"{{dataItem && dataItem.MyInvoice.SupDocsCount + ' ' + (dataItem && dataItem.MyInvoice.SupDocsCount == 1 ? 'Zusatzdokument' : 'Zusatzdokumente') }}\"></span>"
        };
        var colEdit = <GridColumn>{
            width: kconstants.KendoGrid_ActionIconColumnSize,
            template: "<span class='idms_Icon idms_Icon_Edit idms_HoverIcon' ng-click='dataItem.EditRowItem()' title='Beleg bearbeiten'></span>"
        };
        var colRemark = <GridColumn>{
            title: "Bemerkung",
            width: 300,
            field: "_Source.Remark",
            template: "<textarea class='k-textbox' ng-class='!dataItem._Source.Disabled && dataItem._Source.SelectedAction.RemarkMandatory && !dataItem._Source.Remark ? \"idms_Invalid\" : \"\"' style='width: 100%; height: 48px;' title='{{dataItem._Source.Remark}}' ng-model='dataItem._Source.Remark' ng-disabled='dataItem._Source.Disabled' ></textarea>",
        };

        /** If set represents the Workflow Instances Selected from UI */
        var selectionData: ObservableArray;

        var gridOptions = <NavGridOptions>{
            columns: fn.FlattenArray([[colEdit, colPreview, colState], myInVoiceCols, [colSelectAction, colSelComment, colRemark]]),
            dataSource: GetGridDataSource(instanceData), // Resolve NaN Paging issue : paging only settable correctly with explicit DataSource
            resizable: true,
            reorderable: true,
            sortable: true,
            groupable: true,
            columnMenu: true,
            selectable: true,
            dataBound: e => {
                // Select all unlocked items
                var grid = <INavGridImp>e.sender;
                var selInfo = grid.GetSelectedItems();
                // caution : databound get's called often!
                if (selectionData)
                    selectionData.unbind("change", refreshCommonActions);
                else if (selInfo) {
                    // Select all unlocked invoice data on startup and disable locked data (except by me)
                    instanceData.filter(item => !!item._Model.CheckedOutBy && (CurrentUser && CurrentUser.ID) !== item._Model.CheckedOutBy).forEach(item => {
                        // Show locked by as error
                        item.RefreshState({ Disabled: true, IsError: true, Error: "In Bearbeitung von " + item._Model.CheckedOutBy });
                    });
                    var selectedData = instanceData.filter(item => !item._Model.CheckedOutBy || (CurrentUser && CurrentUser.ID) === item._Model.CheckedOutBy);
                    selInfo.SetSelected(true, ... <any[]>selectedData);
                    refreshCommonActions();

                    selectionData = selInfo.GetSelectedItems();
                    selectionData.bind("change", refreshCommonActions);
                }
            },
            customMultiSelect: true,
            customColMenu: true,
        };
        UpdateGridOptions(gridOptions);

        // Setup User Settings
        var getGrid = () => <INavGrid>$scope["gridMassInstances"];
        if (UserSettings) {
            UserSettings.Add("GridSettings", GetGridOptionSettings(gridOptions, getGrid));
            const afterLoad = () => { $scope["GridOptions"] = gridOptions; };
            UserSettings.Load().then(afterLoad, afterLoad);
            $scope["ResetUserSettings"] = UserSettings.Reset.bind(UserSettings);
            $scope.$on("$destroy", () => UserSettings.Save());
        } else {
            // Init grid without user settings
            $scope["GridOptions"] = gridOptions;
        }

        /** Check  Mass Mandatory Actions (some get Validated per item
        - Reauthenticate
        - Signature
        */
        function ValidateMandatoryActions(this: void) {
            var instances = selectedInstances;
            operationInfo.ReAuthenticated.length = 0;
            // Check for Forced Reauthentication
            var toReAuthInstances = instances.map(item => item._Source).filter(item => item.SelectedAction && item.SelectedAction.Reauthenticate);
            return $c.when(toReAuthInstances.length > 0 &&
                ReAuthenticate($c).then(() => { operationInfo.ReAuthenticated = toReAuthInstances; }))
                .then(CheckSignMandatoryValid).then(fn.ToFunc(instances));
        }

        /** Action : start Routing for All Items  */
        var startAll = $scope["StartAll"] = <IInfOperation>{
            Enabled: true,
            Execute: () => {
                if (operationInfo.StartedOperation)
                    throw new Error("Operation bereits gestartet!");

                startAll.Enabled = propagateComment.Enabled = false;
                cancelAll.Enabled = true;
                operationInfo.Cancelled = false;
                // Build Concatenated Routing Operation
                var myOperation = operationInfo.StartedOperation = ValidateMandatoryActions().then((selectedInstances) =>
                    selectedInstances.reduce((collectedItems, currentInstance) => collectedItems.then(() => {
                        var route = $c.when(currentInstance._State.IsError ? $c.reject(currentInstance._State.Error || "Fehler") : currentInstance._Source.Route());
                        return route.then(fn.noop, fn.noop);
                    }), $c.when()).then(fn.ToFunc(selectedInstances)));
                myOperation.then(() => {
                    // at the end :
                    // - remove successfully routed instances and close window if no items remaining
                    var toKeep = instanceData.filter(d => !d._State.IsDone),
                        allDone = toKeep.length == 0,
                        anyDone = toKeep.length !== instanceData.length;
                    if (anyDone && !allDone) {
                        // Remove handled items
                        instanceData.splice(0, instanceData.length, ...toKeep);
                    }
                    if (allDone || instanceData.length == 0)
                        closeWindow();
                });
                const afterOperation = () => {
                    if (myOperation == operationInfo.StartedOperation) {
                        operationInfo.StartedOperation = undefined;
                    };
                    startAll.Enabled = propagateComment.Enabled = true;
                    cancelAll.Enabled = false;
                    // Allow to act on Signature Error again
                    instanceData.map(item => item._State.SignDocError && (item._State.IsError = false));
                    refreshInstanceStates();
                };
                myOperation.then(afterOperation, afterOperation);
                refreshInstanceStates();
                refreshCommonActions(myOperation);
                return myOperation;
            }
        };

        /** Action : Cancel Current Routing Process */
        var cancelAll = $scope["CancelAll"] = <IInfOperation>{
            Enabled: false,
            Execute: () => {
                if (!operationInfo.StartedOperation)
                    return $c.when();

                startAll.Enabled = false;
                operationInfo.Cancelled = true;
                var prevStarted = operationInfo.StartedOperation;
                var myOperation = operationInfo.StartedOperation = prevStarted.then(() => {
                    var result = $c.defer();
                    const afterStart = () => {
                        try {
                            return $c.all(instanceData.map(item => item._Source.Close())).then(() => result.resolve(), () => result.resolve());
                        } catch (err) { result.reject(err); }
                    };
                    $c.all([prevStarted]).then(afterStart, afterStart);
                    return result.promise;
                });
                cancelAll.Enabled = false;
                // Build Concatenated Routing Operation
                const afterOp = () => {
                    cancelAll.Enabled = true;
                    if (operationInfo.StartedOperation == myOperation) {
                        operationInfo.StartedOperation = undefined;
                    };
                    startAll.Enabled = propagateComment.Enabled = true;
                    cancelAll.Enabled = false;
                    refreshInstanceStates();
                };
                myOperation.then(afterOp, afterOp);

                refreshInstanceStates();
                return myOperation;
            }
        };

        /** Action : Close window  */
        var kWindow: kendo.ui.Window;
        $scope.$watch("::MassWindow", (w: kendo.ui.Window) => (kWindow = w));
        $scope.$on($ModalRequestClose, (ae) => {
            if (operationInfo.StartedOperation) {
                DialogService.ShowError("Das Fenster kann nicht geschlossen werden. Bitte warten Sie die laufende Operation ab oder brechen Sie diese ggf. ab!");
                ae.preventDefault();
            }
        });
        $scope.$on("$destroy", NavSettings.RegisterOnBeforeUnload((ev) => {
            if (operationInfo.StartedOperation) {
                ev.preventDefault();
                ev.returnValue = "Bitte warten Sie die laufende Operation ab oder brechen Sie diese ggf. ab!";
            }
        }));
        var closeWindow = $scope["closeWindow"] = () => {
            if (operationInfo.ClosePending)
                return;
            if (kWindow) {
                operationInfo.ClosePending = true;
                if (operationInfo.StartedOperation)
                    operationInfo.StartedOperation.then(() => kWindow.close(), () => kWindow.close());
                else
                    kWindow.close();
            }
        };

        /** Action : Copy comment to all items currently editable */
        var propagateComment = $scope["PropagateComment"] = <IInfOperation>{
            Execute: () => {
                updateSelectedInstances();
                selectedInstances.filter(item => !item._State.Disabled).forEach(info => info._Source.Remark = commonInfo.Remark);
            },
            Enabled: true
        };

        operationInfo.bind(ExternalRefresh, refreshCommonActions);

        // Warning : this is the final fallback, Should be triggered on scope shutdown gracefully!
        $scope.$on("$destroy", () => { cancelAll.Execute(); });
    }
};

/**  compare Actions, matching from Users Perspective **/
function compareAction(a1: IKWFRoutingAction, a2: IKWFRoutingAction) {
    if (!a1)
        return !a2;

    return actionId(a1) == actionId(a2);
}

/** Actions of different Instances are "identified" by title if possible (from users perspective, 2 * 'zurück' is considered same ...)
* TODO : Duplicate Titles per Action will break the system right now */
function actionId(a: IKWFRoutingAction) {
    if (!a)
        return "";

    // In case of "UserTitle" Title : take users perpective (for top actions only)
    var title = (a._GroupItem && (a._GroupedTitle + a._GroupItem.Title)) || a.Title;
    if (title)
        return a.WFActionType + ":" + title;
    // fallback : technical keys ...
    return (a.WFActionCode + ":" + a.WFUserID + ":" + a.WFActionType + ":" + a.WFActionNextPartCode + ":" + a.WFActionNextStepCode);
};
